import React from "react";
import "./HomePageFooter.css";

/* ── platform & news source logos ── */
import fbLogo from "../images/Facebook-Logo-wide.png";
import telegramLogo from "../images/telegram.png";
import igLogo from "../images/insta6-300x85.png";
import ytLogo from "../images/youtube-wide.png";
import xLogo from "../images/twitter.png";
import threadsLogo from "../images/threads.png";
import dailyLogo from "../images/dailymotion-png.png";
import hinduLogo from "../images/THEHINDU.jpg";
import wireLogo from "../images/WIRE.png";
import scrollLogo from "../images/SCROLL.png";
import newsminuteLogo from "../images/newsminute.png";
import laundryLogo from "../images/CHIMTI.png";
import muslimLogo from "../images/MUSLIM MIRROR.png";
import expressLogo from "../images/INDIAN EXPRESS.jpg";
import abpLogo from "../images/abp.png";
import deccanLogo from "../images/pngegg.png";
import heraldLogo from "../images/DECCAN HERALD.png";
import bhaskarLogo from "../images/BHASKAR.png";
import printLogo from "../images/THEPRINT.png";
import guardianLogo from "../images/GUARDIAN.png";
import jazeeraLogo from "../images/JAZEERA.png";
import ndtvLogo from "../images/NDTV.png";
import nbtLogo from "../images/NBT.png";
import risingKashmirLogo from "../images/RisingKashmir.png";
import indiaTodayLogo from "../images/IndiaToday.png";
import toiLogo from "../images/TOI.png";
import outlookLogo from "../images/outlook.jpg";
import linkedinLogo from "../images/linkedin.png";
import redditLogo from "../images/reddit.png";
import pinterestLogo from "../images/Pinterest.png";
import tumblrLogo from "../images/tumblr.png";
import quoraLogo from "../images/Quora.png";
import mojLogo from "../images/Moj.webp";
import joshLogo from "../images/josh.png";

/* ═══════════════════════════════════════════════════════════════
   `shape` fixes the size inconsistency in the strip.

   One max-width can't serve both kinds of artwork. A WORDMARK
   (LinkedIn, Pinterest, The Guardian) is ~4:1 — it hits the width
   cap while its height stays large. A SQUARE / BADGE mark (TOI,
   NDTV, Al Jazeera) is ~1:1 — it never reaches the width cap, so
   only the height cap applies and it renders as a tiny stamp
   beside the wordmarks.

   So each shape is sized by its own constraint (see the CSS):
     wide   → capped by width, moderate height
     square → capped by height, allowed to be TALLER so its
              optical mass matches the wordmarks

   If a logo still looks off, flip its shape here — that's the
   only change needed.
   ═══════════════════════════════════════════════════════════════ */
const PLATFORMS = [
  // ── Social ──
  { name: "Facebook",        img: fbLogo,          shape: "wide" },
  { name: "Instagram",       img: igLogo,          shape: "wide" },
  { name: "Twitter",         img: xLogo,           shape: "square" },
  { name: "Threads",         img: threadsLogo,     shape: "square" },
  { name: "YouTube",         img: ytLogo,          shape: "wide" },
  { name: "Telegram",        img: telegramLogo,    shape: "square" },
  { name: "LinkedIn",        img: linkedinLogo,    shape: "wide" },
  { name: "Reddit",          img: redditLogo,      shape: "wide" },
  { name: "Pinterest",       img: pinterestLogo,   shape: "wide" },
  { name: "Tumblr",          img: tumblrLogo,      shape: "wide" },
  { name: "Quora",           img: quoraLogo,       shape: "wide" },
  { name: "Moj",             img: mojLogo,         shape: "square" },
  { name: "Josh",            img: joshLogo,        shape: "square" },
  { name: "Daily Motion",    img: dailyLogo,       shape: "wide" },

  // ── News ──
  { name: "Times Of India",  img: toiLogo,         shape: "square" },
  { name: "The Hindu",       img: hinduLogo,       shape: "square" },
  { name: "The Wire",        img: wireLogo,        shape: "square" },
  { name: "Scroll",          img: scrollLogo,      shape: "wide" },
  { name: "News Minute",     img: newsminuteLogo,  shape: "square" },
  { name: "News Laundry",    img: laundryLogo,     shape: "square" },
  { name: "Muslim Mirror",   img: muslimLogo,      shape: "square" },
  { name: "Indian Express",  img: expressLogo,     shape: "wide" },
  { name: "ABP News",        img: abpLogo,         shape: "square" },
  { name: "Deccan Chronicle",img: deccanLogo,      shape: "wide" },
  { name: "Deccan Herald",   img: heraldLogo,      shape: "wide" },
  { name: "Dainik Bhaskar",  img: bhaskarLogo,     shape: "wide" },
  { name: "The Print",       img: printLogo,       shape: "wide" },
  { name: "The Guardian",    img: guardianLogo,    shape: "wide" },
  { name: "Al Jazeera",      img: jazeeraLogo,     shape: "square" },
  { name: "NDTV News",       img: ndtvLogo,        shape: "square" },
  { name: "Nav Bharat Times",img: nbtLogo,         shape: "square" },
  { name: "India Today",     img: indiaTodayLogo,  shape: "wide" },
  { name: "Rising Kashmir",  img: risingKashmirLogo, shape: "square" },
  { name: "Outlook India",   img: outlookLogo,     shape: "wide" },
];

export default function HomePageFooter() {
  return (
    <footer
      className="csl-marquee"
      aria-label="Data sources we continuously monitor"
    >
      <span className="csl-marquee__label">Monitoring</span>

      <div className="csl-marquee__viewport">
        <div className="csl-marquee__track">
          {[0, 1].map((copy) => (
            <div
              className="csl-marquee__group"
              key={copy}
              aria-hidden={copy === 1}
            >
              {PLATFORMS.map((p, i) => (
                <span
                  className="csl-marquee__item"
                  data-shape={p.shape || "wide"}
                  key={i}
                  title={p.name}
                >
                  {p.img ? (
                    <img
                      src={p.img}
                      alt={copy === 0 ? p.name : ""}
                      className="csl-marquee__logo"
                      loading="lazy"
                      decoding="async"
                      draggable="false"
                    />
                  ) : (
                    p.name
                  )}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
}